import { Button } from "components/buttons/button";
import { BookCardDataFragment } from "lib/graphql-generated";
import { useBasket } from "lib/hooks/basket/use-basket";
import { useIsInBasket } from "lib/hooks/basket/use-is-in-basket";
import Link from "next/link";
import currency from "currency.js";
import { Spinner } from "components/spinner";

interface Props {
  books: BookCardDataFragment[];
  handleMore: (e?: any) => void;
  loading: boolean;
}
export const BookReccomendations = ({ books, handleMore, loading }: Props) => {
  const [_, reducer] = useBasket();
  const isInBasket = useIsInBasket;

  return (
    <section className='[ order-5 ] w-full p-8 bg-green-very-light lg:order-6'>
      <div className='space-y-6 md:space-y-0 max-w-screen-xl mx-auto md:grid md:grid-cols-2 md:gap-8 lg:grid-cols-4 '>
        <div className='col-span-full md:w-full flex flex-col md:flex-row flex-wrap justify-center md:justify-between relative space-y-2'>
          <h2 className='ml-auto mr-auto md:ml-0 uppercase tracking-wide font-header text-2xl '>
            More great books
          </h2>
          <button
            className='ml-auto mr-auto md:ml-0 md:mr-8 hover:bg-white hover:text-green-default font-bold group transform hover:scale-110 duration-75 border border-green-default md:border-none rounded-full px-4 '
            onClick={handleMore}>
            Load MORE{" "}
            <span className='inline-block transform group-hover:-rotate-12 duration-75'>
              !
            </span>
            <span className='inline-block transform group-hover:-translate-y-0.5 duration-75'>
              ?
            </span>
            <span className='inline-block transform group-hover:rotate-12 duration-75'>
              !
            </span>
          </button>
        </div>
        {loading ? (
          <div className='col-span-full flex flex-row justify-center min-h-96'>
            <Spinner size={10} />
          </div>
        ) : books && books.length > 0 ? (
          books.map((bookRec, i) => (
            <article
              key={bookRec.isbn}
              className='max-w-2xs mx-auto lg:ml-0 space-y-4 flex flex-col justify-between h-full'>
              <Link href={`/book/${bookRec.isbn}`}>
                <a>
                  <img
                    alt={`Image for book: ${bookRec.title}`}
                    src={bookRec.image}
                    className='transform transition-transform ease-in hover:-translate-y-3'
                  />
                </a>
              </Link>
              <section className='mt-auto border-t-8 pt-4 border-black font-header uppercase tracking-wide flex justify-between'>
                <span>
                  {" "}
                  {currency(
                    bookRec.is_discounted
                      ? bookRec.price - bookRec.discount_value
                      : bookRec.price,
                    {
                      symbol: "£",
                      fromCents: true,
                    }
                  ).format()}
                </span>

                <Button
                  className='mb-auto uppercase tracking-wide font-header'
                  disabled={isInBasket(bookRec.isbn)}
                  onClick={() =>
                    reducer({
                      type: "add",
                      payload: {
                        type: "book",
                        id: bookRec.isbn,
                        data: {
                          price: bookRec.price,
                          discount: bookRec.is_discounted
                            ? bookRec.discount_value
                            : 0,
                          quantity: 1,
                          book: {
                            isbn: bookRec.isbn,
                            image: bookRec.image,
                            title: bookRec.title,
                          },
                        },
                      },
                    })
                  }>
                  {isInBasket(bookRec.isbn)
                    ? "In Basket"
                    : bookRec.tag_books_aggregate.aggregate.count > 0
                    ? "Pre-Order"
                    : "Add to basket"}
                </Button>
              </section>
            </article>
          ))
        ) : (
          ""
        )}
      </div>
    </section>
  );
};
